var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("shareProductController", [
    "$scope",
    "$rootScope",
    "productService",
    "loaderService",
    "storefrontApp.mainContext",
    "modalService",
    "mainService",
    function (
        $scope,
        $rootscope,
        productService,
        loaderService,
        storefrontAppMainContext,
        modalService,
        mainService
    ) {
        var referProductDefault = {
            toEmailId: "",
            fromEmailId: "",
            message: "",
            copyMe: false,
            itemId: "",
        };

        $scope.isSpecial = false;

        $scope.$watch(
            function () {
                return storefrontAppMainContext.customer;
            },
            function () {
                if (storefrontAppMainContext.customer) {
                    $scope.customer = storefrontAppMainContext.customer;
                }
            }
        );

        $scope.shareOnFacebook = function () {
            return (
                "https://www.facebook.com/sharer/sharer.php?u=" +
                window.location.href
            );
        };

        $scope.shareOnPintrest = function () {
            if ($rootscope.currentProduct != null) {
                return (
                    "http://pinterest.com/pin/create/button/?url=" +
                    window.location.href +
                    "&media=" +
                    $rootscope.currentProduct.imgUrl
                );
            }
        };

        //#region REFER A Product
        $scope.openReferProduct = function (saleUrlShare) {
            if ($scope.customer && $scope.customer.isRegisteredUser) {
                $rootscope.referProduct = angular.copy(referProductDefault);
                $rootscope.referProduct.fromEmailId = $scope.customer.email;

                if (
                    window.location.pathname.toLowerCase().includes("specials")
                ) {
                    mainService
                        .getModuleKeys("ShareProduct")
                        .then(function (response) {
                            if (response && response.data) {
                                $scope.isSpecial = true;
                                var images = response.data.filter(function (x) {
                                    return (
                                        x.key.toLowerCase() == "specialimage"
                                    );
                                });

                                var image = "";

                                if (images != null && images.length > 0) {
                                    image = images[0].value;
                                }

                                $rootscope.referProduct.message =
                                    document.getElementById(
                                        "refermessagespecial"
                                    ).value;
                                $rootscope.referProduct.message =
                                    $rootscope.referProduct.message.replace(
                                        "[[saleurlreplace]]",
                                        saleUrlShare
                                    );
                                $rootscope.currentProduct = {};

                                $rootscope.currentProduct.imgUrl = image;
                            }
                        });
                } else if (
                    window.location.pathname.toLowerCase().includes("thread")
                ) {
                    mainService
                        .getModuleKeys("ShareProduct")
                        .then(function (response) {
                            if (response && response.data) {
                                $scope.isSpecial = false;
                                var images = response.data.filter(function (x) {
                                    return x.key.toLowerCase() == "threadimage";
                                });

                                var image = "";

                                if (images != null && images.length > 0) {
                                    image = images[0].value;
                                }

                                $rootscope.referProduct.message =
                                    document.getElementById(
                                        "refermessage"
                                    ).value;
                                $rootscope.currentProduct = {};

                                $rootscope.currentProduct.imgUrl = image;
                            }
                        });
                } else {
                    $scope.isSpecial = false;
                    $rootscope.referProduct.message =
                        document.getElementById("refermessage").value;
                }
                $scope.toggleModal("referProduct", true);
            } else {
                var returnURL =
                    window.location.pathname + window.location.search;
                $scope.outerRedirect(
                    $scope.baseUrl +
                        "account/login?returnurl=" +
                        returnURL.replace("&", "%26")
                );
            }
        };

        $rootscope.closeReferProduct = function (referproductform) {
            $scope.toggleModal("referProduct");
            resetReferProductModal(referproductform);
        };

        resetReferProductModal = function (referproductform) {
            $rootscope.referProduct = angular.copy(referProductDefault);
            referproductform.$setPristine();
            referproductform.$setUntouched();
        };

        $scope.toggleModal = function (key, state) {
            if (state) {
                modalService.open(key);
            } else {
                modalService.close(key);
            }
        };

        $rootscope.sendEmailOnReferProduct = function (
            referProduct,
            referproductform
        ) {
            var form_data = new FormData();
            if (
                referproductform.copyMe.$valid &&
                referproductform.fromEmail.$valid &&
                referproductform.message.$valid &&
                referproductform.recaptcha.$valid &&
                referproductform.toEmail.$valid
            ) {
                loaderService.show();
                referProduct.itemId = $scope.prodId;

                if (referProduct.itemId == null) {
                    referProduct.itemId = "Specials";
                }

                form_data.append("referProduct", angular.toJson(referProduct));
                form_data.append(
                    "g-Recaptcha-Response",
                    referProduct.recaptchaResponse
                );
                productService
                    .sendEmailOnReferProduct(form_data)
                    .then(function (response) {
                        if (
                            response &&
                            response.data &&
                            response.data.success
                        ) {
                            loaderService.hide();
                            $scope.closeReferProduct(referproductform);
                            alert(
                                "Votre e-mail est en file d'attente pour livraison"
                            );
                        } else {
                            loaderService.hide();
                            $scope.closeReferProduct(referproductform);
                            alert("Quelque chose s'est mal passé");
                        }
                    });
            } else {
                loaderService.hide();
            }
        };
        //#endregion
    },
]);
